module.exports = __webpack_public_path__ + "static/media/vineetAgarwal.2b8472eb.svg";